class ProductModalLoginCart {
  constructor() {
    this.selectors = {
      closeButton: 'js-productLoginCartModalClose',
      submitButton: 'js-productLoginCartModalSubmit',
    }

    this.modal = new Modal('js-productLoginCartModal');

    window.addEventListener('modal-open', this.$onModalOpen);

    this.$init();
    this.$addModalOpenListener();
  }

  $init() {
    this.elements = {
      closeButton: document.querySelectorAll(`.${this.selectors.closeButton}`),
      submitButton: document.getElementById(this.selectors.submitButton),
    }

    this.elements.closeButton.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        this.modal.close();
      });
    })

    this.elements.submitButton.addEventListener('click', () => {
      window.location = this.elements.submitButton.getAttribute('data-link');
    })
  }

  $addModalOpenListener() {
    window.addEventListener('modal-open', this.$onModalOpen);
  }

  $onModalOpen = () => {
    localStorage.setItem('isShownProductModalCartLogin', 'true')
  };
}

document.addEventListener('DOMContentLoaded', () => {
  window.productModalLoginCart = new ProductModalLoginCart();
})
